import { Radio as MuiRadio } from '@mui/material';
import { forwardRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { useEntityPermission } from '../../providers/EntityPermissionProvider/index';
import ReadOnly from './ReadOnly';

const Radio = forwardRef(
  (
    { overwriteProps = {}, ...props },
    ref,
    // eslint-disable-next-line arrow-body-style
  ) => {
    const { getValues } = useFormContext();
    const { isHidden, isReadOnly } = useEntityPermission();

    const currentvalue = getValues(props?.name);

    if (isReadOnly(props?.permission, currentvalue)) {
      return (
        <ReadOnly name={props?.name}>{currentvalue ? 'Yes' : 'No'}</ReadOnly>
      );
    }

    if (isHidden(props?.permission)) {
      return <input type="hidden" name={props?.name} value={currentvalue} />;
    }
    return <MuiRadio ref={ref} {...props} {...overwriteProps} />;
  },
);

export default Radio;
